import PromoTag from './PromoTag.mjs';

export default function PromoTypes({ promo, promoTypesTax }) {
  const apiPromoTypes = promo.promotionTypes;
  let mappedTags = [];

  if (promo.category.value === 'special') {
    mappedTags.push(
      <PromoTag
        key={'promo-type-special-' + Math.floor(Math.random() * 99999)}
        apiTag="SPECIAL_EVENT"
        promoTypes={promoTypesTax}
      />,
    );
  }

  if (apiPromoTypes && apiPromoTypes.length > 0) {
    let mappedPromoElements = apiPromoTypes.map(p => {
      return (
        <PromoTag
          key={'promo-type-' + p + '-' + Math.floor(Math.random() * 99999)}
          apiTag={p}
          promoTypes={promoTypesTax}
        />
      );
    });

    mappedTags.push(mappedPromoElements);
  }

  return mappedTags.length > 0 ? <div className="d-flex flex-wrap gap-2">{mappedTags}</div> : false;;
}
